import { render, staticRenderFns } from "./SFileBox.vue?vue&type=template&id=0f1cfe8b&scoped=true&"
import script from "./SFileBox.vue?vue&type=script&lang=js&"
export * from "./SFileBox.vue?vue&type=script&lang=js&"
import style0 from "./SFileBox.vue?vue&type=style&index=0&id=0f1cfe8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1cfe8b",
  null
  
)

export default component.exports